// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";
import { colorProfileValidationObject } from "@dashboardApi/apis/engagementInAppMessageColorProfilesId";

export const isEngagementInAppMessageColorProfilesDuplicateResult = objectOf({
  info: string,
  template: colorProfileValidationObject,
});
